var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l_walk"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},_vm._l((this.faqs),function(data,index){return _c('div',{key:index,staticClass:"faqlist"},[_c('Accordion',{ref:data.id,refInFor:true,attrs:{"question":data.question,"ans":data.a,"innerPageLink":_vm.scrollToAnchorPoint}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }